<template lang="html">
  <div class="project-filter">
    <div class="project-filter__focus-links">
      <nuxt-link
        :to="{
          path: $route.path,
          query: {
            view: $route.query.view
          }
        }"
        :class="{ 'project-filter__link--active': !$route.query.focus }"
        class="project-filter__link project-filter__link--neutral"
      >
        Alle
      </nuxt-link>
      <nuxt-link
        v-for="focus in allFocusItems"
        :key="focus.id"
        :to="{
          path: $route.path,
          query: {
            view: $route.query.view,
            focus: focus.id
          },
        }"
        :class="[
          'project-filter__link',
          { 'project-filter__link--active': $route.query.focus === focus.id },
          `project-filter__link--${focus.id}`
        ]"
      >
        {{ focus.label }}
      </nuxt-link>
    </div>
    <div class="project-filter__list-switch">
      <nuxt-link
        :class="{ 'project-filter__switch--active': $route.query.view !== 'list' }"
        class="project-filter__switch"
        :to="{
          query: {
            view: 'grid',
            focus: $route.query.focus
          }
        }"
      >
        Vorschau
        <svgGridView class="project-filter__icon" />
      </nuxt-link>
      <nuxt-link
        :class="{ 'project-filter__switch--active': $route.query.view === 'list' }"
        class="project-filter__switch"
        :to="{
          query: {
            view: 'list',
            focus: $route.query.focus
          }
        }"
      >
        Liste
        <svgListView class="project-filter__icon" />
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import svgGridView from 'beisheim/assets/images/icons/gridview.svg'
import svgListView from 'beisheim/assets/images/icons/listview.svg'

export default {
  components: {
    svgGridView,
    svgListView
  },
  data () {
    return {
      allFocusItems: [ // TODO move to resources
        {
          id: 'bildung',
          label: 'Bildung'
        },
        {
          id: 'gesundheit',
          label: 'Gesundheit'
        },
        {
          id: 'kultur',
          label: 'Kultur'
        },
        {
          id: 'sport',
          label: 'Sport'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/colors';

  $component: '.project-filter';
  $component-breakpoint: 3;

  #{$component} {
    display: flex;
    flex-direction: column;
    margin: scale(1) auto scale(8) auto;
    min-width: $min-width;
    max-width: $max-width;
    @include grid-spacing(padding-left, 2);
    @include grid-spacing(padding-right, 2);

    @include from($component-breakpoint) {
      border-bottom: 1px solid gray(3);
    }

    @include from($component-breakpoint) {
      flex-direction: row;
    }

    &__icon {
      width: scale(9);
      height: scale(9);
    }

    &__list-switch {
      display: flex;
      border-top: 1px solid gray(3);
      border-bottom: 1px solid gray(3);
      @include from($component-breakpoint) {
        flex-basis: 30%;
        border-top: none;
        border-bottom: none;
      }
    }

    &__switch {
      display: flex;
      justify-content: center;
      align-items: center;
      @include font(0.5);
      flex-basis: 50%;
      text-align: center;
      margin-top: scale(3);
      margin-bottom: scale(3);
      cursor: pointer;
      color: gray(3);
      fill: gray(3);
      transition: color 200ms ease-in-out, fill 200ms ease-in-out;

      &:hover {
        color: gray(0);
        fill: gray(0);
      }

      &--active {
        color: gray(0);
        fill: gray(0);
      }

      &:first-child {
        border-right: 1px solid gray(3);
        @include from($component-breakpoint) {
          border-right: none;
        }
      }

      @include from($component-breakpoint) {
        @include font(0);
        flex-basis: 50%;
      }
    }

    &__focus-links {
      display: flex;
      flex-wrap: wrap;
      border-top: 1px solid gray(3);
      padding-top: scale(2);
      padding-bottom: scale(2);
      @include from($component-breakpoint) {
        flex-basis: 70%;
        border-top: none;
      }
    }

    &__link {
      position: relative;
      @include font(1);
      padding: scale(2) scale(3);
      margin: scale(1);
      white-space: nowrap;
      border-radius: scale(4);

      &::before {
        content: '';
        display: inline-block;
        position: relative;
        top: 0.15rem;
        left: -0.1rem;
        width: scale(3);
        height: scale(3);
        border-radius: 50%;
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: gray(4);
        border-radius: scale(4);
        transition: transform 200ms ease-out, opacity 100ms ease-out;
        opacity: 0;
        transform: scaleX(1.2) scaleY(1.2);
        z-index: -1;
      }

      &:hover, &:focus {
        &::after {
          transform: scaleX(1) scaleY(1);
          opacity: 1;
        }
      }

      &--active {
        &::after {
          transform: scaleX(1) scaleY(1);
          opacity: 1;
        }
      }

      @include from($component-breakpoint) {
        @include font(0);
        height: scale(8);
      }

      &--bildung {
        &::before {
          background-color: brand(3);
        }
      }
      &--gesundheit {
        &::before {
          background-color: brand(4);
        }
      }
      &--kultur {
        &::before {
          background-color: brand(1);
        }
      }
      &--sport {
        &::before {
          background-color: brand(2);
        }
      }
      &--neutral {
        &::before {
          background-color: gray(2);
        }
      }
    }
  }
</style>
